// Parke Mock Data
// Parke siparişleri, kategori takibi ve stok yönetimi

export const parkeSiparisler = [
    {
        id: 'pk-001',
        siparisTarihi: '2026-01-08',
        teslimTarihi: '2026-01-12',
        tedarikci: 'Kronospan',
        tedarikciFirmaId: 'f-020',
        kategori: 'laminat',
        urunAdi: 'Kronospan Mega Plus',
        ebat: '1380x193mm',
        kalinlik: '8mm',
        miktar: 250,
        birim: 'kutu',
        birimFiyat: 320,
        toplamFiyat: 80000,
        kdvOrani: 20,
        kdvTutari: 16000,
        kdvDahilToplam: 96000,
        durum: 'teslim',
        insaatId: 'c-001',
        depoKonumu: 'Ana Depo',
        stokMiktar: 50,
        kullanilanMiktar: 200,
        tedariKaynagi: 'tedarikci',
        not: 'Daire salon döşemesi',
        createdAt: '2026-01-08T09:00:00Z',
        updatedAt: '2026-01-20T14:00:00Z',
    },
    {
        id: 'pk-002',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-01-15',
        tedarikci: 'Doğtaş Parke',
        tedarikciFirmaId: 'f-021',
        kategori: 'masif',
        urunAdi: 'Meşe Masif Parke',
        ebat: '600x90mm',
        kalinlik: '18mm',
        miktar: 80,
        birim: 'kutu',
        birimFiyat: 850,
        toplamFiyat: 68000,
        kdvOrani: 20,
        kdvTutari: 13600,
        kdvDahilToplam: 81600,
        durum: 'teslim',
        insaatId: 'c-002',
        depoKonumu: 'B Blok Depo',
        stokMiktar: 25,
        kullanilanMiktar: 55,
        tedariKaynagi: 'tedarikci',
        not: 'Salon ve yatak odaları',
        createdAt: '2026-01-10T10:00:00Z',
        updatedAt: '2026-01-22T11:00:00Z',
    },
    {
        id: 'pk-003',
        siparisTarihi: '2026-01-15',
        teslimTarihi: '2026-01-18',
        tedarikci: 'AGT',
        tedarikciFirmaId: 'f-022',
        kategori: 'laminat',
        urunAdi: 'AGT Effect Serisi',
        ebat: '1200x191mm',
        kalinlik: '10mm',
        miktar: 180,
        birim: 'kutu',
        birimFiyat: 380,
        toplamFiyat: 68400,
        kdvOrani: 20,
        kdvTutari: 13680,
        kdvDahilToplam: 82080,
        durum: 'teslim',
        insaatId: 'c-001',
        depoKonumu: 'Ana Depo',
        stokMiktar: 30,
        kullanilanMiktar: 150,
        tedariKaynagi: 'tedarikci',
        not: 'Yatak odaları döşemesi',
        createdAt: '2026-01-15T08:00:00Z',
        updatedAt: '2026-01-25T16:00:00Z',
    },
    {
        id: 'pk-004',
        siparisTarihi: '2026-01-20',
        teslimTarihi: null,
        tedarikci: 'Kronospan',
        tedarikciFirmaId: 'f-020',
        kategori: 'engineered',
        urunAdi: 'Kronospan Engineered Oak',
        ebat: '1200x180mm',
        kalinlik: '14mm',
        miktar: 120,
        birim: 'kutu',
        birimFiyat: 650,
        toplamFiyat: 78000,
        kdvOrani: 20,
        kdvTutari: 15600,
        kdvDahilToplam: 93600,
        durum: 'bekliyor',
        insaatId: 'c-001',
        depoKonumu: null,
        stokMiktar: 0,
        kullanilanMiktar: 0,
        tedariKaynagi: 'tedarikci',
        not: 'Premium daireler için',
        createdAt: '2026-01-20T11:00:00Z',
        updatedAt: '2026-01-20T11:00:00Z',
    },
    {
        id: 'pk-005',
        siparisTarihi: '2026-01-28',
        teslimTarihi: '2026-01-30',
        tedarikci: null,
        tedarikciFirmaId: null,
        kategori: 'laminat',
        urunAdi: 'AGT Effect Serisi',
        ebat: '1200x191mm',
        kalinlik: '10mm',
        miktar: 20,
        birim: 'kutu',
        birimFiyat: 0,
        toplamFiyat: 0,
        kdvOrani: 0,
        kdvTutari: 0,
        kdvDahilToplam: 0,
        durum: 'teslim',
        insaatId: 'c-003',
        depoKonumu: 'C Blok Şantiye',
        stokMiktar: 5,
        kullanilanMiktar: 15,
        tedariKaynagi: 'stoktan',
        not: 'A Blok stokundan aktarım',
        createdAt: '2026-01-28T09:00:00Z',
        updatedAt: '2026-02-01T10:00:00Z',
    },
];

// Parke kategorileri
export const parkeKategorileri = [
    { key: 'laminat', label: 'Laminat Parke', aciklama: 'Ekonomik, dayanıklı, kolay döşeme' },
    { key: 'masif', label: 'Masif Parke', aciklama: 'Doğal ahşap, premium kalite' },
    { key: 'engineered', label: 'Engineered Parke', aciklama: 'Katmanlı yapı, boyutsal stabilite' },
];

// Parke durumları
export const parkeDurumlari = [
    { key: 'bekliyor', label: 'Bekliyor', color: 'warning' },
    { key: 'teslim', label: 'Teslim Edildi', color: 'success' },
    { key: 'iptal', label: 'İptal', color: 'error' },
];

// Stok özeti
export const getParkeStok = (insaatId) => {
    const filtered = insaatId
        ? parkeSiparisler.filter(s => s.insaatId === insaatId && s.durum === 'teslim')
        : parkeSiparisler.filter(s => s.durum === 'teslim');

    const stokByKategori = {};
    filtered.forEach(s => {
        const key = s.kategori;
        if (!stokByKategori[key]) {
            stokByKategori[key] = { kategori: key, stok: 0, kullanilan: 0 };
        }
        stokByKategori[key].stok += s.stokMiktar;
        stokByKategori[key].kullanilan += s.kullanilanMiktar;
    });

    return Object.values(stokByKategori);
};

// İstatistikler
export const getParkeStats = (insaatId) => {
    const filtered = insaatId
        ? parkeSiparisler.filter(s => s.insaatId === insaatId)
        : parkeSiparisler;

    const toplamKutu = filtered.reduce((acc, s) => acc + s.miktar, 0);
    const teslimKutu = filtered.filter(s => s.durum === 'teslim').reduce((acc, s) => acc + s.miktar, 0);
    const stokKutu = filtered.filter(s => s.durum === 'teslim').reduce((acc, s) => acc + s.stokMiktar, 0);
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);

    return {
        toplamKutu,
        teslimKutu,
        stokKutu,
        toplamMaliyet,
        siparisAdedi: filtered.length,
    };
};

// Helper: İnşaata göre filtrele
export const getParkeByInsaat = (insaatId) => {
    if (!insaatId) return parkeSiparisler;
    return parkeSiparisler.filter(s => s.insaatId === insaatId);
};
